import React, { useEffect } from 'react';
import PrivacyPolicyBody from './PrivacyPolicyBody';
import '../../styles/Common.css';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="info-modal-overlay privacy-policy-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="privacy-policy-title">
      <div className="info-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="info-modal-close" onClick={onClose} aria-label="Закрыть">×</button>
        <h2 id="privacy-policy-title" className="info-modal-title">Политика в отношении обработки персональных данных на интернет-сайте</h2>
        <div className="info-modal-content">
          <div className="privacy-policy-content">
            <PrivacyPolicyBody />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
